import camelcase from "camelcase";

export function transformComparisonFields(fields = []) {
  return fields.map((field) => {
    return { ...field, lookupName: camelcase(field.columnName) };
  });
}
